/**
 * Test component for Sentry error tracking.
 * Import and render temporarily (e.g. on Settings or any page) to verify events reach Sentry.
 * Remove or hide in production if you don't want a visible test button.
 */
import * as Sentry from "@sentry/react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

export function SentryErrorButton() {
  const { toast } = useToast();

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => {
        toast({
          title: "Sending test error to Sentry…",
          description: "The error will appear in Sentry → Issues. This page will show an error screen.",
        });
        // Throw after a short delay so the toast is visible before the error boundary takes over
        setTimeout(() => {
          throw new Error("Sentry test: This is your first error!");
        }, 300);
      }}
    >
      Test Sentry (throw error)
    </Button>
  );
}

/** Manually capture a test message (no throw). Use to verify Sentry is receiving events. */
export function SentryTestMessageButton() {
  const { toast } = useToast();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => {
        Sentry.captureMessage("Sentry test message (no error)", "info");
        toast({
          title: "Test message sent to Sentry",
          description: "Check your Sentry project → Issues (or search for 'Sentry test message').",
        });
      }}
    >
      Test Sentry (message only)
    </Button>
  );
}
